module.exports = __webpack_public_path__ + "img/ski-boot.ece0a6d5.svg";